import { useState } from "react";
import { MinusCircle } from "lucide-react";
import { num, numStr, parseNum } from "@/lib/format";
import { Button, Chip, Input } from "@/components/kit";

const REASONS = ["Devolução ao fornecedor", "Erro de digitação", "Avaria na entrega", "Lançado em duplicidade"];

export function ReducePanel({ max, unit, fromInvoice, loading, onConfirm, onCancel, testid }) {
  const [qty, setQty] = useState(numStr(max));
  const [reason, setReason] = useState("");
  const q = parseNum(qty);
  const invalid = !(q > 0) || q > max + 1e-9;
  return (
    <div className="rounded-xl p-3 flex flex-col gap-2.5 mt-2" style={{ background: "var(--surface-alt)" }} data-testid={testid}>
      <div className="flex items-end gap-2">
        <label className="flex-1 flex flex-col gap-1"><span className="caption">Quantidade a remover ({unit}) · até {num(max)}</span>
          <Input inputMode="decimal" autoFocus value={qty} onFocus={(e) => e.target.select()} onChange={(e) => setQty(e.target.value)} data-testid={`${testid}-qty`} />
        </label>
        <Button variant="ghost" size="sm" onClick={() => setQty(numStr(max))} data-testid={`${testid}-all`}>Tudo</Button>
      </div>
      <Input maxLength={120} placeholder="Motivo (opcional)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid={`${testid}-reason`} />
      <div className="flex flex-wrap gap-1.5">{REASONS.map((r) => <Chip key={r} active={reason === r} onClick={() => setReason(r)} data-testid={`${testid}-reason-${r.split(" ")[0].toLowerCase()}`}>{r}</Chip>)}</div>
      {fromInvoice && <p className="caption">Veio de nota fiscal · a quantidade e o valor deste item na nota diminuem na mesma proporção.</p>}
      {q > max + 1e-9 && <p className="caption" style={{ color: "var(--danger)" }}>Máximo de {num(max)} {unit}</p>}
      <div className="flex justify-end gap-2">
        <Button variant="ghost" size="sm" onClick={onCancel} data-testid={`${testid}-cancel`}>Cancelar</Button>
        <Button size="sm" icon={MinusCircle} disabled={invalid} loading={loading} onClick={() => onConfirm(q, reason)} style={{ background: invalid ? undefined : "var(--danger)" }} data-testid={`${testid}-confirm`}>{q >= max ? "Remover tudo" : `Remover ${num(q)} ${unit}`}</Button>
      </div>
    </div>
  );
}
